import React from 'react';
import { Modal, List, Typography, Badge } from 'antd';

const handleRequestError = (message, errors) => {
  const formatData = (errorsData) => {
    const firstItem = errorsData[0];
    const formated = [{
      name: firstItem.name,
      attributes: [{
        name: firstItem.attributes.name,
        id: firstItem.attributes.id,
        type: firstItem.type,
      }],
    }];
    return errorsData.reduce((currentResult, currentItem, index) => {
      if (index !== 0) {
        const { name, id } = currentItem.attributes;
        const type = currentItem.type;
        const lastItem = currentResult[currentResult.length - 1];
        if (lastItem.name !== currentItem.name) {
          lastItem.name = currentItem.name;
          lastItem.attributes = [{ name, id, type }];
        } else if (!lastItem.attributes.filter(vendor => vendor.name === name).length) {
          lastItem.attributes.push({ name, id, type });
        }
      }
      return currentResult;
    }, formated);
  };

  return Modal.info({
    title: message,
    content: formatData(errors).map((errorItem, index) => {
      return (
        <List
          header={<Typography.Text strong>{`${errorItem.name}:`}</Typography.Text>}
          key={index}
          type="small"
          dataSource={errorItem.attributes.map(attr => attr.name)}
          renderItem={item => (
            <List.Item>
              <Badge color="#309dd8" text={item} />
            </List.Item>
          )}
        />
      );
    }),
  });
};

export default handleRequestError;



// WEBPACK FOOTER //
// ./src/utils/handleRequestError.js